// src/components/healingProcess.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaShieldAlt, FaSearch, FaTasks, FaLightbulb } from 'react-icons/fa';
import Footer from './footer';
import './healingProcess.css';
import HealingIcon from '../assets/healing-icon.svg';
import SubpagesVector from '../assets/subpages-vector.svg';

function HealingProcess() {
  const { t } = useTranslation();

  return (
    <div className="cybersecurity-posture-view">
      <div className="gradient-background" />

      <div className="cybersecurity-posture-content">
        {/* HERO WRAPPER */}
        <div className="posture-hero-wrapper">
          <div className="posture-hero-background" />
          <div className="posture-hero-container">
            <div className="posture-hero-content">
              <h1 className="posture-title">
                {t('healingCard')}
                <img
                  src={HealingIcon}
                  alt="Healing Process Icon"
                  className="shield-icon"
                />
              </h1>
              <h1 className="assessment-title">{t('healingProcess')}</h1>
              <p className="subtitle">{t('healingHeroSubtitle')}</p>
            </div>
          </div>
        </div>

        {/* RESILIENCE PHASE SECTION */}
        <div className="critical-phase-section">
          <h2 className="critical-phase-subtitle">
            {t('resiliencePhaseSubtitle')}
          </h2>
          <div className="critical-phase-grid">
            {/* Item 1 */}
            <div className="critical-phase-item">
              <div className="critical-phase-title">
                <FaShieldAlt className="critical-phase-icon" />
                <span>{t('holisticArchitectureReview')}</span>
              </div>
              <div className="critical-phase-item-line" />
              <p>{t('holisticArchitectureReviewDesc')}</p>
            </div>
            {/* Item 2 */}
            <div className="critical-phase-item">
              <div className="critical-phase-title">
                <FaSearch className="critical-phase-icon" />
                <span>{t('proactiveThreatHunting')}</span>
              </div>
              <div className="critical-phase-item-line" />
              <p>{t('proactiveThreatHuntingDesc')}</p>
            </div>
            {/* Item 3 */}
            <div className="critical-phase-item">
              <div className="critical-phase-title">
                <FaTasks className="critical-phase-icon" />
                <span>{t('realTimeCVEDefense')}</span>
              </div>
              <div className="critical-phase-item-line" />
              <p>{t('realTimeCVEDefenseDesc')}</p>
            </div>
            {/* Item 4 */}
            <div className="critical-phase-item">
              <div className="critical-phase-title">
                <FaLightbulb className="critical-phase-icon" />
                <span>{t('adaptiveDDoSAndWAFShield')}</span>
              </div>
              <div className="critical-phase-item-line" />
              <p>{t('adaptiveDDoSAndWAFShieldDesc')}</p>
            </div>
          </div>
        </div>

        {/* POST-RESILIENCE PHASE SECTION */}
        <div className="post-critical-phase-section">
          <img
            src={SubpagesVector}
            alt="Subpages Vector"
            className="post-critical-phase-image"
          />
          <p className="post-critical-phase-text">
            {t('postResiliencePhaseText')}
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default HealingProcess;
